import React from "react";
import PropTypes from "prop-types";
import { NavLink, withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faCalendarAlt } from "@fortawesome/free-solid-svg-icons";

import logo from "../assets/img/logo.svg";
import footLogo from "../assets/img/foot-icon-full.svg";

const isFootClinicPage = (pathname) => pathname.indexOf("foot-clinic") >= 0;

const getLogo = (pathname) => {
  if (isFootClinicPage(pathname)) {
    return footLogo;
  }

  return logo;
};

const getLogoClasses = (pathname) => {
  if (isFootClinicPage(pathname)) {
    return "nav__logo--foot";
  }

  return "gs-u-mt+";
};

/**
 * Nav component
 *
 * @param {object} props
 */
const Nav = ({ location, setIsModalOpen }) => {
  const { pathname } = location;
  return (
    <React.Fragment>
      <div className="nav gs-o-media-island gel-1/1">
        <ul className="nav__list gs-u-display-inline gs-u-float-left gs-u-mt+">
          <li className="nav__item gs-u-display-inline gs-u-mr+">
            <a href="tel:01683 222796" className="gs-u-pv">
              <FontAwesomeIcon icon={faPhone} className="gs-u-mr" />
              <span>01683 222796</span>
            </a>
          </li>
        </ul>
        <NavLink
          className={`nav__logo gs-u-display-inline-block ${getLogoClasses(
            pathname
          )}`}
          to="/"
        >
          <img src={getLogo(pathname)} alt="The Moffat Clinic" />
        </NavLink>
        <a
          className="button nav__book_now nav__item gs-u-pv+ gs-u-ph+ gs-u-ph++@l gs-u-float-right"
          href="/foot-clinic/booking"
        >
          <FontAwesomeIcon icon={faCalendarAlt} className="gs-u-mr@l" />
          <span>Book now</span>
        </a>
      </div>
    </React.Fragment>
  );
};

Nav.propTypes = {
  location: PropTypes.object.isRequired,
};

export default withRouter(Nav);
